import { getIPs } from '../../assets/js_validator/ip_validator.js';

export const httpGetIP = new Promise((resolve, reject) => {
    getIPs().then((res: any[]) => resolve('' + res[0]));
});